<template>
  <div class="card is-shadowless rounded-10 outline">
    <div class="pa-3">
      <vue-icon-base
        class="ml-3 mr-1"
        height="16"
        width="16"
        :path="$options.icons[$kc('uni-bar-line')]"
      >
      </vue-icon-base>
      {{ $t('Job Overview') }}
    </div>
    <hr class="is-marginless hr-line" />
    <div class="card-content">
      <div class="card is-flex pa-4">
        <div class="is-flex is-flex-direction-column border-right mr-3 pa-2">
          <a class="has-text-centered" @click="goToApplicationPage()">{{
            applied_count || 0
          }}</a>
          <div>
            {{ $t('Job Applied') }}
          </div>
        </div>
        <div class="is-flex is-flex-direction-column pa-2">
          <div class="has-text-centered">{{ views_count || 0 }}</div>
          <div>
            {{ $t('Job Viewed') }}
          </div>
        </div>
      </div>
      <div v-if="showDoughnutChart" class="card pa-4">
        <div>
          {{ $t('Job Application Status') }}
        </div>
        <doughnut-chart
          class="pa-4 height-10rem"
          :chart-data="chartData"
          :options="options"
        ></doughnut-chart>
        <div class="columns is-flex pa-2">
          <div class="is-full-width has-text-light-blue pointer">
            <span
              v-for="status in statuses"
              :key="status.text"
              class="is-flex gap-05rem"
            >
              <div
                @click="goToApplicationPageFilter(status.value)"
                class="pointer"
              >
                <vue-icon-base
                  class="mt-1"
                  height="16"
                  width="16"
                  :path="$options.icons[$kc('uni-check-box-blank')]"
                  :iconColor="colors[status.value]"
                >
                </vue-icon-base>
                {{ status.text }}
              </div>
            </span>
          </div>
          <div class="column pa-1 is-2 pointer">
            <div
              v-for="data in datasets"
              :key="data.id"
              class="has-margin-top-2px"
            >
              <div
                class="has-text-light-blue"
                @click="goToApplicationPageFilter(status.value)"
              >
                {{ data }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueIconBase from '@/components/Commons/VueIconBase'
import { uniBarLine, uniCheckBoxBlank } from '@/helpers/icons'
import DoughnutChart from '@/components/Charts/DoughnutChart.vue'
import { getResouceUrl } from '@/helpers/utils/searchUtils'
export default {
  components: {
    DoughnutChart,
    VueIconBase
  },
  icons: {
    uniBarLine,
    uniCheckBoxBlank
  },
  data() {
    const options = {
      legend: {
        display: false
      },
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        animateRotate: true
      }
    }
    return {
      showDoughnutChart: false,
      slug: '',
      datasets: [],
      statuses: [
        { text: this.$t('Unscreened'), value: 'Unscreened' },
        { text: this.$t('Screened'), value: 'Screened' },
        { text: this.$t('Shortlisted'), value: 'Shortlisted' },
        { text: this.$t('Interviewed'), value: 'Interviewed' },
        { text: this.$t('Selected'), value: 'Selected' },
        { text: this.$t('Hold'), value: 'hold' },
        { text: this.$t('Rejected'), value: 'Rejected' }
      ],
      colors: {
        Unscreened: '#97989a',
        Screened: '#e1a80c',
        Shortlisted: '#3273dc',
        Interviewed: '#e49228',
        Selected: '#16a347',
        on_hold: '#325481',
        Rejected: '#ef636c'
      },
      applied_count: null,
      views_count: null,
      loading: false,
      options,
      chartData: {},
      contentUrl: `/api/v1/job/${this.$route.params.jobSlug}/applications`,
      showChart: true
    }
  },
  watch: {
    showChart: {
      handler() {
        this.chartData = {
          labels: [
            this.$t('Unscreened'),
            this.$t('Screened'),
            this.$t('Shortlisted'),
            this.$t('Interviewed'),
            this.$t('Selected'),
            this.$t('Hold'),
            this.$t('Rejected')
          ],
          datasets: [
            {
              backgroundColor: [
                '#97989a',
                '#e1a80c',
                '#3273dc',
                '#e49228',
                '#16a347',
                '#325481',
                '#ef636c'
              ],
              data: this.datasets
            }
          ]
        }
      },
      deep: true
    }
  },
  created() {
    this.getData()
  },
  methods: {
    goToApplicationPage() {
      const val = ''
      this.$store.commit('job/setJobType', val)
      this.$router.push(
        this.localePath({
          name: 'job-jobSlug-applications',
          params: {
            jobSlug: this.slug
          }
        })
      )
    },
    goToApplicationPageFilter(val) {
      if (this.localePath) {
        this.$store.commit('job/setJobType', val)
        this.$router.push(
          this.localePath({
            name: 'job-jobSlug-applications',
            params: {
              jobSlug: this.slug
            }
          })
        )
      }
    },
    async getData() {
      if (this.loading) return
      this.loading = true
      const resourceUrl = getResouceUrl(this.contentUrl)
      const { data } = await this.$axios.get(resourceUrl)
      this.$store.commit('collection/setCollectionData', [
        `jobApplications${this.$route.params.jobSlug}`,
        data
      ])
      this.data = data.stats
      this.views_count = data.extra_info.hit_count
      this.applied_count = data.stats.Total
      if (this.applied_count !== 0) {
        this.showDoughnutChart = true
      }
      this.slug = data.extra_info.slug
      this.datasets = [
        data.stats.Applied,
        data.stats.Screened,
        data.stats.Shortlisted,
        data.stats.Interviewed,
        data.stats.Selected,
        data.stats.hold,
        data.stats.Rejected
      ]
      this.loading = false
      this.showChart = !this.showChart
    }
  }
}
</script>
